import { List } from 'immutable';

import { NotFoundError } from '../lib/APIClient';
import { resolveAll, resolve } from '../helpers/LinkMapper';
import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';
import Address from '../records/customer/Address';

const AddressService = {

    getBaseUrl(user) {
        return `/customers/${user.id}`;
    },

    async getAll (user) {
        try {
            const endpoint = `${this.getBaseUrl(user)}/addresses`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            return resolveAll(response.result).as(Address);
        } catch (error) {
            if (!(error instanceof NotFoundError)) {
                throw error;
            }
            return new List();
        }
    },

    async get (user, addressId) {
        try {
            const endpoint = `${this.getBaseUrl(user)}/addresses/${addressId}`;
            const response = await AuthenticatedAPIClient.get(endpoint);
            return resolve(response.result).as(Address);
        } catch (error) {
            return null;
        }
    },

    async create(user, address, isDefault = false) {
        const endpoint = `${this.getBaseUrl(user)}/addresses`;
        const updatedAddress = address.set('default', isDefault);
        const response = await AuthenticatedAPIClient.post(endpoint, updatedAddress.toJS());
        return resolve(response.result).as(Address);
    },

    async delete(user, address) {
        const endpoint = `${this.getBaseUrl(user)}/addresses/${address.id}`;
        await AuthenticatedAPIClient.delete(endpoint);
        return true;
    },

    async update(user, address, isDefault = false) {
        const endpoint = `${this.getBaseUrl(user)}/addresses/${address.id}`;
        const updatedAddress = address.set('default', isDefault);
        const response = await AuthenticatedAPIClient.put(endpoint, updatedAddress.getUpdateRequestJSON());
        return resolve(response.result).as(Address);
    }

};


export default AddressService;



// WEBPACK FOOTER //
// ./src/services/AddressService.js